$(document).ready(function() {
  $('.logged-in-tiers').slick({
    arrows: true,
    dots: false,
    infinite: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"></button>'
  });
  $('.logged-in-tiers-mobile').slick({
    arrows: false,
    dots: true,
    infinite: true
  });
  $('.single-item').slick({
    arrows: false,
    dots: true,
    infinite: false
  });
  $('.multiple-items').slick({
    arrows: false,
    dots: true,
    infinite: false,
    swipeToSlide: false,
    touchThreshold: 10,
    draggable: true,
    variableWidth: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    mobileFirst: true,
    responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  const selectLevelThruImageCoordinates = (e) => {
    const offset_t = $(e.currentTarget).offset().top - $(window).scrollTop();
    const offset_l = $(e.currentTarget).offset().left - $(window).scrollLeft();
    const w = $(e.currentTarget).width(); // Width  (Rendered)
    const h = $(e.currentTarget).height(); // Height (Rendered)
    const nw = $(e.currentTarget).attr("width"); // Width  (Natural)
    const nh = $(e.currentTarget).attr("height"); // Height (Natural)
    const left = Math.round((e.clientX - offset_l));
    const top = Math.round((e.clientY - offset_t));
    const x = Math.round((left * nw) / w);
    const y = Math.round((top * nh) / h);
    const popupImg = $('.popup_rewards.level_selector');
    const popupTempImgSrc = popupImg.find('img').data('tempSrc');

    $(e.currentTarget).css('cursor','pointer');
    if (y <= 460 && y >= 280 && x <= 942 && x >= 830) { // Level 4
      if (e.type === 'click') {
        if (window.matchMedia("(max-width: 1000px)").matches){
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0434/1438/8897/files/Group_209_1.svg?v=1716210954'))
        }
        else {
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0463/0488/6950/files/level4_pound.png?v=1728407353'))
        }
        popupImg.show();
      }
    } 
    else if (y <= 460 && y >= 280 && x <= 320 && x >= 180) {  // Level 3
      if (e.type === 'click') {
        if (window.matchMedia("(max-width: 1000px)").matches){
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0463/0488/6950/files/mob_level3_pound.png?v=1728409097'))
        }
        else{
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0463/0488/6950/files/level3_pound.png?v=1728407352'))
        }
        popupImg.show();
      }
    } 
    else if (y <= 1020 && y >= 835 && x <= 1120 && x >= 985) {  // Level 2
      if (e.type === 'click') {
        if (window.matchMedia("(max-width: 1000px)").matches){
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0463/0488/6950/files/mob_level2_pound.png?v=1728409097'))
        }
        else{
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0463/0488/6950/files/level2_pound.png?v=1728407352'))
        }
        popupImg.show();
      }
    } 
    else if (y <= 1395 && y >= 1215 && x <= 560 && x >= 415) {  // Level 1
      if (e.type === 'click') {
        if (window.matchMedia("(max-width: 1000px)").matches){
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0434/1438/8897/files/Group_208_2.svg?v=1716211521'))
        }
        else {
        popupImg.find('img').attr('src', popupTempImgSrc.replaceAll('to_replace', 'https://cdn.shopify.com/s/files/1/0434/1438/8897/files/rewards-level1.svg?v=1716202486'))
        }
        popupImg.show();
      }
    } 
    else if (e.type === 'mousemove') {
      $(e.currentTarget).css('cursor','unset');
    }
  }

  $('body').on('mousemove click', '#logged-out-footer', selectLevelThruImageCoordinates);
  $('.popup_rewards.level_selector .overlay, .popup_rewards.level_selector span').on('click', () => {
    $('.popup_rewards.level_selector').hide();
  });
});